// const READ_IMG_WIDTH = 640; //640
// const READ_IMG_HEIGHT = 480; //480

const READ_IMG_WIDTH = 256;
const READ_IMG_HEIGHT = 256;

function binarizeImg(src, dst, inv = false) {
  window.cv.adaptiveThreshold(
    src,
    dst,
    255,
    window.cv.ADAPTIVE_THRESH_GAUSSIAN_C,
    inv ? window.cv.THRES_BINARY_INV : window.cv.THRESH_BINARY,
    11,
    7
  );
}

function sharpen(src, dst, kSize = 5) {
  let M = window.cv.Mat.eye(kSize, kSize, window.cv.CV_32FC1);
  let anchor = new window.cv.Point(-1, -1);
  // You can try more different parameters
  window.cv.filter2D(
    src,
    dst,
    window.cv.CV_8U,
    M,
    anchor,
    0,
    window.cv.BORDER_DEFAULT
  );
}
function dilate(src, dst, kSize = 5) {
  let M = window.cv.Mat.ones(kSize, kSize, window.cv.CV_8U);
  let anchor = new window.cv.Point(-1, -1);
  // You can try more different parameters
  window.cv.dilate(
    src,
    dst,
    M,
    anchor,
    1,
    window.cv.BORDER_CONSTANT,
    window.cv.morphologyDefaultBorderValue()
  );
}

function erode(src, dst, kSize = 5) {
  let M = window.cv.Mat.ones(kSize, kSize, window.cv.CV_8U);
  let anchor = new window.cv.Point(-1, -1);
  // You can try more different parameters
  window.cv.erode(
    src,
    dst,
    M,
    anchor,
    1,
    window.cv.BORDER_CONSTANT,
    window.cv.morphologyDefaultBorderValue()
  );
}

function erodeAndDilateImg(src, dst, kSize = 3) {
  let M = window.cv.Mat.ones(kSize, kSize, window.cv.CV_8U);
  let anchor = new window.cv.Point(-1, -1);
  // You can try more different parameters
  window.cv.morphologyEx(
    src,
    dst,
    window.cv.MORPH_OPEN,
    M,
    anchor,
    1,
    window.cv.BORDER_CONSTANT,
    window.cv.morphologyDefaultBorderValue()
  );
}

function blurImg(dst, kSize = 3, blurType = "gaussian") {
  let ksize = new window.cv.Size(kSize, kSize);
  let anchor = new window.cv.Point(-1, -1);

  switch (blurType) {
    // gaussian blur
    case "median":
      window.cv.medianBlur(dst, dst, 5);
    default:
      window.cv.GaussianBlur(dst, dst, ksize, 0, 0, window.cv.BORDER_DEFAULT);
  }
}

function resizeImg(dst, width, height) {
  let dsize = new window.cv.Size(width, height);
  window.cv.resize(dst, dst, dsize, 0, 0, window.cv.INTER_AREA);
}

function isSufficientSize(cntr, minArea = 5000, minPerimeter = 400) {
  const area = window.cv.contourArea(cntr, false);
  if (area >= minArea) {
    return true;
  }
  return false;
}

function isValidSquare(rect) {
  const width = rect.width;
  const height = rect.height;

  const diff = (width - height) / height;
  if (Math.abs(diff) < 0.15) {
    return true;
  }
  return false;
}

function isSquare(cntr, minArea, rectVertices) {
  let poly = new window.cv.Mat();
  const perimeter = window.cv.arcLength(cntr, true);
  window.cv.approxPolyDP(cntr, poly, 0.05 * perimeter, true);

  let rect = window.cv.boundingRect(poly);
  // if has 4 sides (8 params)
  const points = poly.data32S;
  if (
    (points.length === 4 * 2) &
    isValidSquare(rect) &
    isSufficientSize(poly, minArea)
  ) {
    if (rectVertices) {
      rectVertices.push(points);
    }
    return true;
  }
  return false;
}

function detectSquare(
  dst,
  dst2,
  gridExtractCntrs,
  gridExtractCntrsCenter,
  minArea,
  rectVertices = null
) {
  let cntrs = new window.cv.MatVector();
  let hierarchy = new window.cv.Mat();

  window.cv.findContours(
    dst,
    cntrs,
    hierarchy,
    window.cv.RETR_LIST,
    window.cv.CHAIN_APPROX_SIMPLE
  );

  const color = new window.cv.Scalar(
    Math.round(0),
    Math.round(255),
    Math.round(0)
  );

  for (let i = 0; i < cntrs.size(); ++i) {
    let cntr = cntrs.get(i);
    if (!isSquare(cntr, minArea, rectVertices)) {
      continue;
    }
    const moment = window.cv.moments(cntr); //center of contour
    let cx = moment.m10 / moment.m00;
    let cy = moment.m01 / moment.m00;

    gridExtractCntrs.push(cntr);
    gridExtractCntrsCenter.push({x: cx, y: cy});

    window.cv.drawContours(
      dst2,
      cntrs,
      i,
      color,
      2,
      window.cv.LINE_8,
      hierarchy,
      0
    );

    break; // already found the rect
  }
}

function detectLines(src, dst, lineAnglesArr) {
  let lines = new window.cv.Mat();
  // window.cv.HoughLines(src, lines, 1, Math.PI / 180, 120, 0, 0, 0, Math.PI);
  window.cv.HoughLines(src, lines, 1, Math.PI / 180, 70, 0, 0, 0, Math.PI);

  const color = new window.cv.Scalar(
    Math.round(255),
    Math.round(0),
    Math.round(0)
  );

  // draw lines
  for (let i = 0; i < lines.rows; ++i) {
    let rho = lines.data32F[i * 2];
    let theta = lines.data32F[i * 2 + 1];

    let angle = (theta * 180) / Math.PI;
    lineAnglesArr.push(angle);

    let a = Math.cos(theta);
    let b = Math.sin(theta);
    let x0 = a * rho;
    let y0 = b * rho;
    let startPoint = {x: x0 - 1000 * b, y: y0 + 1000 * a};
    let endPoint = {x: x0 + 1000 * b, y: y0 - 1000 * a};
    window.cv.line(dst, startPoint, endPoint, color, 1);
  }
}

function clusterAngles(lineAnglesArr) {
  // given an array of angles, find the perpendicular angles (avg)
  // the groups of angles should be ~ 90 degrees diff

  const tol = 10; // allow some lenience from orthogonality
  const angles1 = [];
  const angles2 = [];

  let lastAngle1;
  let lastAngle2;

  lineAnglesArr.forEach((angle, idx) => {
    if (idx === 0) {
      angles1.push(angle);
      lastAngle1 = angle;
    } else {
      // if (angle > 90) {
      //   angle -= 90;
      // }
      if (Math.abs(angle - lastAngle1) <= tol) {
        angles1.push(angle);
        lastAngle1 = angle;
      } else {
        angles2.push(angle);
        lastAngle2 = angle;
      }
    }
  });

  const meanAngles1 = angles1.reduce((p, c) => (c += p), 0) / angles1.length;
  const meanAngles2 = angles2.reduce((p, c) => (c += p), 0) / angles2.length;

  if (meanAngles1 <= meanAngles2) {
    return [parseInt(meanAngles1), parseInt(meanAngles2)];
  } else {
    return [parseInt(meanAngles2), parseInt(meanAngles1)];
  }
}

function extractGrid(src, cntr) {
  const rect = window.cv.boundingRect(cntr);
  let dst = new window.cv.Mat();
  if ((rect.x > 5) & (rect.y > 5)) {
    rect.x -= 5;
    rect.y -= 5;
    rect.height += 5;
    rect.width += 5;
  }
  dst = src.roi(rect);
  return dst;
}

function orderPoints(arr) {
  // helps to orient the warp perspective
  // arr has 8 elements [top left, top right, bottom right, bottom left]
  const newPts = [];

  const pairSum = [];
  // find pair with smallest sum
  for (let i = 0; i < arr.length; i += 2) {
    pairSum.push(arr[i] + arr[i + 1]);
  }

  // want to make sure point with smallest sum is at the left of the array
  let minVal = Math.min(...pairSum);
  let minValIdx = 0;
  for (let i = 0; i < pairSum.length; ++i) {
    if (pairSum[i] === minVal) {
      minValIdx = i;
      break;
    }
  }

  // shift orig array by the idx of minval * 2 to the right
  // perform twice for every pair
  const newArr = [...arr];
  for (let i = 0; i < minValIdx * 2; ++i) {
    let firstEl = newArr.shift();
    newArr.push(firstEl);
  }
  return newArr;
}

function perspectiveTransform(src, dst, srcRectVertices, width, factor) {
  let dsize = new window.cv.Size(dst.rows, dst.cols);
  const orderedVertices = orderPoints(srcRectVertices);
  let srcTri = window.cv.matFromArray(
    4,
    1,
    window.cv.CV_32FC2,
    orderedVertices
  );
  let dstTri = window.cv.matFromArray(4, 1, window.cv.CV_32FC2, [
    0,
    0,
    width * factor,
    0,
    width * factor,
    width * factor,
    0,
    width * factor,
  ]);
  let M = window.cv.getPerspectiveTransform(srcTri, dstTri);
  // You can try more different parameters
  window.cv.warpPerspective(
    src,
    dst,
    M,
    dsize,
    window.cv.INTER_LINEAR,
    window.cv.BORDER_CONSTANT,
    new window.cv.Scalar()
  );

  return M;
}

function getCellCenterBlob(src) {
  let contours = new window.cv.MatVector();
  let hierarchy = new window.cv.Mat();
  window.cv.findContours(
    src,
    contours,
    hierarchy,
    window.cv.RETR_LIST,
    window.cv.CHAIN_APPROX_SIMPLE
  );
  for (let i = 0; i < contours.size(); ++i) {
    let cnt = contours.get(i);
    // You can try more different parameters
    let M = window.cv.moments(cnt, false);
    let cx = M.m10 / M.m00;
    let cy = M.m01 / M.m00;
    console.log(`${cx}, ${cy}`);
  }
}

function getCellVals(
  src,
  dst,
  canvas,
  ctx,
  dilateImg = false,
  erodeImg = false,
  drawLines = false
) {
  // input perspective transformed image
  // return an array of ROIs and draws onto the dst

  const height = src.rows;
  const width = src.cols;

  const cellHeight = height / 9;
  const cellWidth = width / 9;

  // get cell images
  const cellValImagesUrl = [];
  const cellValImagesRoi = [];
  for (let i = 0; i < 9; ++i) {
    for (let j = 0; j < 9; ++j) {
      let rect = new window.cv.Rect(
        j * cellWidth,
        i * cellHeight,
        cellWidth,
        cellHeight
      );

      let roi = src.roi(rect);
      // getCellCenterBlob(roi);
      const newWidth = 50;
      const newHeight = 50;
      resizeImg(roi, newWidth, newHeight);

      let rectCell = {
        x: newWidth * 0.25,
        y: newHeight * 0.25,
        width: newWidth * 0.5,
        height: newHeight * 0.5,
      };
      let newRoi = roi.roi(rectCell);

      if (dilateImg) {
        dilate(newRoi, newRoi);
      }
      if (erodeImg) {
        erode(newRoi, newRoi);
      }

      canvas.width = newRoi.cols;
      canvas.height = newRoi.rows;
      let s = new window.cv.Scalar(255, 255, 255, 255);

      // let dst = new window.cv.Mat();
      // window.cv.copyMakeBorder(
      //   newRoi,
      //   dst,
      //   5,
      //   5,
      //   5,
      //   5,
      //   window.cv.BORDER_CONSTANT,
      //   s
      // );
      // resizeImg(dst, 28, 28);
      // cellValImagesRoi.push(dst);
      // window.cv.imshow(canvas, dst);

      resizeImg(newRoi, 28, 28);
      cellValImagesRoi.push(newRoi);
    }
  }

  if (drawLines) {
    const color = new window.cv.Scalar(
      Math.round(255),
      Math.round(0),
      Math.round(0)
    );

    let startPoint;
    let endPoint;
    // draw rows
    for (let i = 0; i < 9; ++i) {
      startPoint = {x: -1000, y: i * cellHeight};
      endPoint = {x: 1000, y: i * cellHeight};
      window.cv.line(dst, startPoint, endPoint, color, 2);
    }
    // draw cols
    for (let i = 0; i < 9; ++i) {
      startPoint = {x: i * cellWidth, y: -1000};
      endPoint = {x: i * cellWidth, y: 1000};
      window.cv.line(dst, startPoint, endPoint, color, 2);
    }
  }

  return [cellValImagesUrl, cellValImagesRoi];
}

export default function PreprocessImg(
  src,
  //img,
  thresholdViewCanvas,
  contourViewCanvas,
  gridExtractViewCanvas,
  linesViewCanvas,
  adjGridExtractViewCanvas,
  extractCellViewCanvas,
  width,
  height,
  factor
) {
  var ttotal0 = performance.now();
  var t0 = performance.now();

  console.log("starting to preprocess img");
  //let src = window.cv.imread(img);
  //src = window.cv.imread(img);
  // console.log("loaded src");
  let dst = new window.cv.Mat();
  console.log("created dst");
  window.cv.cvtColor(src, dst, window.cv.COLOR_RGBA2GRAY, 0);
  console.log("converted gray");

  var t1 = performance.now();
  console.log("converting image to grey took " + (t1 - t0) + " milliseconds.");

  t0 = performance.now();
  resizeImg(dst, width * factor, height * factor);
  t1 = performance.now();
  // console.log(
  //   "\t resizing, eroding, and bluring to grey took " +
  //     (t1 - t0) +
  //     " milliseconds."
  // );

  t0 = performance.now();
  let dst2 = window.cv.Mat.zeros(dst.rows, dst.cols, window.cv.CV_8UC3);
  binarizeImg(dst, dst2);
  t1 = performance.now();
  console.log("\t binarizing img took" + (t1 - t0) + " milliseconds");
  // console.log("binarized");

  t0 = performance.now();
  let dst3 = window.cv.Mat.zeros(dst.rows, dst.cols, window.cv.CV_8UC3);
  let gridExtractCntrs = [];
  let gridExtractCntrsCenter = [];
  let rectVertices = [];
  detectSquare(
    dst2,
    dst3,
    gridExtractCntrs,
    gridExtractCntrsCenter,
    30000,
    // parseInt(width * height * 0.07 * factor),
    rectVertices
  );
  t1 = performance.now();
  console.log("\t finding contours took " + (t1 - t0) + " milliseconds.");
  // console.log("found squares");

  t0 = performance.now();

  let dst6 = window.cv.Mat.zeros(
    width * factor,
    width * factor,
    window.cv.CV_8UC3
  );

  let cellValsImages = [[], []];
  let perspectiveTransformM;
  if (rectVertices.length > 0) {
    t0 = performance.now();
    perspectiveTransformM = perspectiveTransform(
      dst2,
      dst6,
      rectVertices[0],
      width,
      factor
    );
    t1 = performance.now();
    console.log(
      "\t perspective transform took " + (t1 - t0) + " milliseconds."
    );

    // invert image
    window.cv.bitwise_not(dst6, dst6);
    // fix broken characters
    // erode(dst6, dst6, 3);
    // dilate(dst6, dst6, 3);

    blurImg(dst6, 3, "median");
    t0 = performance.now();

    // used to convert mat to base 64
    let canvasTmp = document.createElement("canvas");
    let ctxTmp = canvasTmp.getContext("2d");
    // cellValsImages = getCellVals(dst6, dst6, canvasTmp, ctxTmp);
    cellValsImages = getCellVals(dst6, dst6, linesViewCanvas, ctxTmp);
    t1 = performance.now();
    // console.log("\t Call to getCellVals took " + (t1 - t0) + " milliseconds.");
  }
  console.log("persp transform");

  // window.cv.imshow(canvas, dst);

  const resizeFactor = 0.5;
  resizeImg(dst2, width * resizeFactor, height * resizeFactor);
  resizeImg(dst3, width * resizeFactor, height * resizeFactor);
  resizeImg(dst6, height * resizeFactor, height * resizeFactor);
  window.cv.imshow(thresholdViewCanvas, dst2);
  window.cv.imshow(contourViewCanvas, dst3);
  window.cv.imshow(extractCellViewCanvas, dst6);

  var ttotal1 = performance.now();
  console.log(
    "Preprocessing image took " + (ttotal1 - ttotal0) + " milliseconds."
  );

  dst.delete();
  dst2.delete();
  dst3.delete();
  dst6.delete();

  if (cellValsImages[1].length > 0) {
    // window.cv.imshow(linesViewCanvas, cellValsImages[1][0]);
    return {cellValsImages: cellValsImages[1], M: perspectiveTransformM};
  } else {
    return {cellValsImages: [], M: null};
  }
}

function overlayText(src, text, pos, col = [0, 0, 255, 255]) {
  window.cv.putText(src, text, pos, window.cv.FONT_HERSHEY_SIMPLEX, 1, col, 3);
}

export function overlayOcrResults(
  srcCanvas,
  dstCanvas,
  dstCanvas2,
  results,
  solution
) {
  const width = srcCanvas.width;
  const height = srcCanvas.height;

  const cellWidth = width / 9;
  const cellHeight = width / 9;

  const src = window.cv.imread(srcCanvas);
  const dst1 = src.clone();
  const dst2 = src.clone();

  // reset destination canvas
  // window.cv.imshow(dstCanvas, src);

  for (let i = 0; i < results.length; ++i) {
    let ocrResult = String(results[i]);
    let xPos = (i % 9) * cellWidth;
    let yPos = Math.ceil((i + 1) / 9) * cellHeight;
    if (ocrResult !== "0") {
      overlayText(dst1, ocrResult, {x: xPos, y: yPos}, [0, 100, 255, 255]);
      overlayText(dst2, ocrResult, {x: xPos, y: yPos}, [0, 100, 255, 255]);
    } else {
      ocrResult = String(solution[i]);
      if (ocrResult === "0") continue;
      overlayText(dst2, ocrResult, {x: xPos, y: yPos}, [0, 255, 0, 255]);
    }
  }
  window.cv.imshow(dstCanvas, dst1);
  window.cv.imshow(dstCanvas2, dst2);
}

export function overlayOcrResultsProjected(
  srcCanvas,
  dstCanvas,
  dst2Canvas,
  M,
  results,
  solution
) {
  // requires 1 input canvases and 1 blank destination canvas
  const width = srcCanvas.width;
  const height = srcCanvas.height;

  const cellWidth = width / 9;
  const cellHeight = width / 9;

  const src = window.cv.imread(srcCanvas);
  const transparentOverlay = new window.cv.Mat.zeros(width, width, src.type());
  const dst = window.cv.imread(dstCanvas);

  for (let i = 0; i < results.length; ++i) {
    let ocrResult = String(results[i]);
    let xPos = (i % 9) * cellWidth;
    let yPos = Math.ceil((i + 1) / 9) * cellHeight;
    if (ocrResult !== "0") {
      overlayText(transparentOverlay, ocrResult, {x: xPos, y: yPos}, [
        0,
        100,
        255,
        255,
      ]);
    } else {
      ocrResult = String(solution[i]);
      if (ocrResult === "0") continue;
      overlayText(transparentOverlay, ocrResult, {x: xPos, y: yPos}, [
        0,
        255,
        0,
        255,
      ]);
    }
  }

  const M_inv = M.inv(window.cv.DECOMP_SVD);
  let dsize = new window.cv.Size(src.cols, src.rows);
  // // You can try more different parameters
  window.cv.warpPerspective(
    transparentOverlay,
    transparentOverlay,
    M_inv,
    dsize,
    window.cv.INTER_LINEAR,
    window.cv.BORDER_CONSTANT,
    new window.cv.Scalar()
  );

  // need to convert pixels where overlay is located in src image to black
  // bc adding together

  // var t0 = performance.now();
  // for (let i = 0; i < transparentOverlay.data32S.length; ++i) {
  //   if (transparentOverlay.data32S[i] !== 0) {
  //     src.data32S[i] = 0;
  //   }
  // }
  // var t1 = performance.now();
  // console.log(
  //   "setting src img where overlay text is => 0 took " +
  //     (t1 - t0) +
  //     " milliseconds."
  // );

  // need to set pixel to 0 in src img where transparentOverlay pixels exist
  try {
    const overlayedImage = new window.cv.Mat.zeros(height, width, src.type());
    window.cv.addWeighted(src, 1, transparentOverlay, 1, 0, overlayedImage);
    window.cv.imshow(dstCanvas, overlayedImage);

    resizeImg(
      overlayedImage,
      overlayedImage.cols * 0.5,
      overlayedImage.rows * 0.5
    );
    window.cv.imshow(dst2Canvas, overlayedImage);
  } catch (err) {
    console.log("error with overlaying image");
    console.log(err);
  }
  // window.cv.imshow(dstCanvas, transparentOverlay);
}
